import { render } from "./LivingWillAgeChart.vue?vue&type=template&id=4a7f1fb8"
import script from "./LivingWillAgeChart.vue?vue&type=script&lang=js"
export * from "./LivingWillAgeChart.vue?vue&type=script&lang=js"
script.render = render

export default script